"use client";
import Image from "next/image";
import { motion } from "framer-motion";
import { parentalFeatures } from "@data";
import { parentalControls } from "@assets";

const ParentalControls = () => {
	return (
		<section className="w-full px-4 sm:px-6 lg:px-8">
			<div className="mx-auto w-full max-w-7xl py-12">
				<div className="flex flex-col items-center justify-between gap-4 md:gap-8 lg:flex-row lg:gap-12">
					<div className="flex max-w-2xl flex-col justify-center gap-6">
						<motion.div className="flex flex-col justify-center gap-1" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
							<h2 className="text-foreground px-2 text-2xl leading-tight font-bold sm:text-3xl md:text-4xl lg:text-4xl">Training with Parental Controls</h2>
							<p className="text-muted-foreground max-w-2xl px-2 text-sm leading-relaxed sm:text-base md:text-lg">Empower kids to learn in a safe, structured environment with parental monitoring tools.</p>
						</motion.div>
						<motion.div className="flex flex-col justify-center gap-6" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.5 }}>
							{parentalFeatures?.map(feature => {
								const Icon = feature?.icon;
								return (
									<div className="flex items-start gap-4" key={feature?.uuid}>
										<div className="bg-secondary/20 mt-2 flex size-10 shrink-0 items-center justify-center rounded-full">
											<Icon className="stroke-secondary" size={20} />
										</div>
										<div className="flex w-full flex-col justify-center gap-1">
											<h3 className="text-foreground text-lg font-semibold">{feature?.title}</h3>
											<p className="text-muted-foreground">{feature?.description}</p>
										</div>
									</div>
								);
							})}
						</motion.div>
					</div>
					<motion.div className="flex items-center justify-center" initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8, delay: 0.3 }}>
						<div className="relative w-full max-w-lg p-5">
							<Image alt="parental-controls" className="h-auto w-full rounded-xl object-contain" priority src={parentalControls} />
						</div>
					</motion.div>
				</div>
			</div>
		</section>
	);
};

export default ParentalControls;
